import React from 'react';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import SettingsIcon from '@mui/icons-material/Settings';
import WebIcon from '@material-ui/icons/Web';
import { Chat } from '@material-ui/icons';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import HistoryIcon from '@mui/icons-material/History';
import QrCode2Icon from '@mui/icons-material/QrCode2';
import CreateIcon from '@mui/icons-material/Create';
import { withCookies } from 'react-cookie';

export const MenuListItemsSignOut = withCookies((props) => {
  const { cookies } = props;
  const commonNameObj = cookies.get('COMMON_NAME_OBJ');
  const talkName = commonNameObj !== undefined ? commonNameObj.TALK_NAME : 'チャット';
  return (
    <div>
      <ListItem button component="a" href="/chat">
        <ListItemIcon>
          <Chat />
        </ListItemIcon>
        <ListItemText primary={`${talkName}履歴`}  />
      </ListItem>

      <ListItem button component="a" href={'/message'}>
        <ListItemIcon>
          <WebIcon />
        </ListItemIcon>
        <ListItemText primary="メッセージ一斉送信" />
      </ListItem>

      <ListItem button component="a" href={'/message/sent'}>
        <ListItemIcon>
          <HistoryIcon />
        </ListItemIcon>
        <ListItemText primary="メッセージ送信履歴" />
      </ListItem>

      <ListItem button component="a" href={'/setting  '}>
        <ListItemIcon>
          <SettingsIcon />
        </ListItemIcon>
        <ListItemText primary="通知先設定" />
      </ListItem>

      <ListItem button component="a" href="/">
        <ListItemIcon>
          <ExitToAppIcon />
        </ListItemIcon>
        <ListItemText primary="ログアウト" />
      </ListItem>
    </div>
  );
});

export const MenuListItemsAddressSignOut = withCookies((props) => {
  const { cookies } = props;
  const commonNameObj = cookies.get('COMMON_NAME_OBJ');
  const chatName = commonNameObj !== undefined ? commonNameObj.CHAT_NAME : 'チャットカテゴリ';
  const talkName = commonNameObj !== undefined ? commonNameObj.TALK_NAME : 'チャット';
  const createFlg = cookies.get('AVAILABLE_CREATE_KUBUN');
  return (
    <div>
      <ListItem button component="a" href="/chat">
        <ListItemIcon>
          <Chat />
        </ListItemIcon>
        <ListItemText primary={`${talkName}履歴`}  />
      </ListItem>

      { createFlg === 'TRUE'  && (
        <ListItem button component="a" href="/category">
          <ListItemIcon>
            <CreateIcon />
          </ListItemIcon>
          <ListItemText primary={`${chatName}作成依頼`} />
        </ListItem>
      )}

      <ListItem button component="a" href="/qr">
        <ListItemIcon>
          <QrCode2Icon />
        </ListItemIcon>
        <ListItemText primary="QRコード発行" />
      </ListItem>

      <ListItem button component="a" href={'/message'}>
        <ListItemIcon>
          <WebIcon />
        </ListItemIcon>
        <ListItemText primary="メッセージ一斉送信" />
      </ListItem>

      <ListItem button component="a" href={'/message/sent'}>
        <ListItemIcon>
          <HistoryIcon />
        </ListItemIcon>
        <ListItemText primary="メッセージ送信履歴" />
      </ListItem>

      <ListItem button component="a" href={'/setting  '}>
        <ListItemIcon>
          <SettingsIcon />
        </ListItemIcon>
        <ListItemText primary="通知先設定" />
      </ListItem>

      <ListItem button component="a" href="/">
        <ListItemIcon>
          <ExitToAppIcon />
        </ListItemIcon>
        <ListItemText primary="ログアウト" />
      </ListItem>
    </div>
  );
});
